<!-- Start Sidemenu Area -->
<div class="sidemenu-area">

    <div class="sidemenu-header right_shade" style="background-color: #143a61!important;">
        <a class="navbar-brand skew-brand d-flex align-items-center">
            <img src="assets/img/skag.png" class="smallimg hidden skew-brand__mark skew-brand__mark--compact" alt="SHRI KRISHNA ENGINEERING WORKS">
            <div class="bigimg skew-brand__full">
                <img src="assets/img/skag.png" class="skew-brand__mark" alt="SHRI KRISHNA ENGINEERING WORKS">
                <div class="skew-brand__text">
                    <span class="skew-brand__title">SKAG</span>
                    
                </div>
            </div>
        </a>
        <div class="burger-menu d-none d-lg-block">
            <span style="background: white;" class="top-bar"></span>
            <span style="background: white;" class="middle-bar"></span>
            <span style="background: white;" class="bottom-bar"></span>
        </div>
        <div class="responsive-burger-menu d-block d-lg-none">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
    </div>

    <div class="sidemenu-body right_shade" style="background-image: url(../../assets/img/Side.jpg);">
        
        <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar
            style="scrollbar-width: 12px; background-color: #ffffffeb; padding-top: 0px;">
            <div *ngFor="let label of appservice.Label_Menu_Rows">
                <li [class]="ac==label.ID?'active nav-item':'nav-item'" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="true"
                        (click)="ac=(label.ID==ac)?0:label.ID" data-toggle="collapse">
                        <span class="icon"><i class='{{label.Icon}}'></i></span>
                        <span class="menu-title">{{label.Display_Name}}</span>
                    </a>
                    <ul class="sidemenu-nav-second-level " *ngIf="ac==label.ID">
                        <li *ngFor="let child of appservice.get_child(label.ID)" class="nav-item"
                            routerLinkActive="active">
                            <a routerLink="{{child.Route_Link}}" class="nav-link">
                                <span class="icon"><i class='{{child.Icon}}'></i></span>
                                <span class="menu-title">{{child.Display_Name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </div>
        </ul>
    </div>
</div>
<!-- End Sidemenu Area -->
